import React from 'react'
import ReactDOM from 'react-dom/client'
// Hook the newsletter modal into the app (see conditional rendering in layouts/base):
import { NewsletterProvider } from './contexts/NewsletterContext'


import App from './App'
import './index.css'

// Wallet Adapter CSS: works well with ours
import '@solana/wallet-adapter-react-ui/styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <NewsletterProvider>
            <App />
        </NewsletterProvider>
    </React.StrictMode>,
)